<template>
  <div>
    <div class="reason" v-if="type == 1 && list.reason">
      未通过原因：{{ list.reason }}
    </div>
    <van-cell-group class="body kuang">
      <van-cell v-if="list.school" title="学校" :value="list.school" />
      <van-cell
        v-if="list.schoolType"
        title="学校类型"
        :value="format(list.schoolType, 11)"
      />
      <van-cell
        v-if="list.schoolBuildingTeam"
        title="学校是否建队"
        :value="format(list.schoolBuildingTeam, 18)"
      />
      <div v-if="list.schoolBuildingTeam == 1">
        <van-cell
          v-if="list.isBrigadeCounselor"
          title="是否为大队辅导员"
          :value="format(list.isBrigadeCounselor, 1)"
        />
        <div v-if="list.isBrigadeCounselor == 1">
          <van-cell v-if="list.name" title="姓名" :value="list.name" />
          <van-cell
            v-if="list.sex"
            title="性别"
            :value="format(list.sex, 12)"
          />
          <van-cell
            v-if="list.birthday"
            title="出生日期"
            :value="format(list.birthday, 6)"
          />
          <van-cell
            v-if="list.edu"
            title="学历"
            :value="format(list.edu, 13)"
          />
          <van-cell
            v-if="list.zzmm"
            title="政治面貌"
            :value="format(list.zzmm, 2)"
          />
          <van-cell v-if="list.tel" title="手机号" :value="list.tel" />
          <van-cell
            v-if="list.job"
            title="校内职务"
            :value="format(list.job, 3)"
          />
          <van-cell
            v-if="list.counselorTime"
            title="担任大队辅导员时间"
            :value="format(list.counselorTime, 6)"
          />
          <van-cell
            v-if="list.title"
            title="职称"
            :value="format(list.title, 4)"
          />
          <van-cell
            v-if="list.concurrentCourses"
            title="兼教课程"
            :value="format(list.concurrentCourses, 17)"
          />
          <van-cell
            v-if="list.classHour"
            title="每周课时"
            :value="list.classHour"
          />
        </div>
      </div>

      <div>
        <van-cell
          v-if="list.eventSchedule"
          title="所在学校的日常少先队活动时间如何安排"
          :value="format(list.eventSchedule, 20)"
        />
        <van-cell
          v-if="list.eventSchedule && list.eventSchedule == 5"
          title="平均每周课时"
          :value="list.eventScheduleOther"
        />
        
        <van-cell
          v-if="list.squadronNum"
          title="中队数量"
          :value="list.squadronNum"
        />
        <van-cell
          v-if="list.squadronCounselorsNum"
          title="中队辅导员人数"
          :value="list.squadronCounselorsNum + '人'"
        />
        <van-cell title="中队辅导员政治面貌：" :border="false" />
        <van-cell
          v-if="list.squadronCounselorsPartyNum"
          title="党员人数"
          :value="list.squadronCounselorsPartyNum + '人'"
        />
        <van-cell
          v-if="list.squadronCounselorsLeagueNum"
          title="团员人数"
          :value="list.squadronCounselorsLeagueNum + '人'"
        />
        <van-cell
          v-if="list.squadronCounselorsPeopleNum"
          title="群众人数"
          :value="list.squadronCounselorsPeopleNum + '人'"
        />
        <van-cell
          v-if="list.squadronCounselorsOtherNum"
          title="其他人数"
          :value="list.squadronCounselorsOtherNum + '人'"
        />

        <!-- <van-cell
          v-if="list.viceCounselor"
          title="副大队辅导员人数"
          :value="format(list.viceCounselor, 19)"
        /> -->
        <van-cell
          v-if="list.viceCounselorNum"
          title="副大队辅导员（执行大队辅导员）人数"
          :value="list.viceCounselorNum + '人'"
        />

        <van-cell
          v-if="list.youngNum"
          title="少先队员人数"
          :value="list.youngNum + '人'"
        />
        <div v-if="list.schoolType > 2">
          <van-cell
            title="今年推荐作为团的发展对象的少先队员人数"
            :value="list.recommender || 0 + '人'"
          />
        </div>

        <van-cell
          title="大队聘请的校外辅导员总人数"
          :value="(list.brigadeOutsideCounselorsNum || 0) + '人'"
        />
        <van-cell
          title="中队聘请的校外辅导员总人数"
          :value="(list.squadronOutsideCounselorsNum || 0) + '人'"
        />
        <div
          v-if="
            (list.schoolType < 9 && list.schoolType >= 5) ||
              list.schoolType <= 2
          "
        >
          <van-cell
            v-if="list.batchTeam"
            title="目前学校学生分几批次入队"
            :value="format(list.batchTeam, 14)"
          />

          <van-cell
            v-if="list.redScarf"
            title="目前学生入队时首次佩戴的红领巾是否由学校统一配发"
            :value="format(list.redScarf, 1)"
          />

          <van-cell
            v-if="list.badge"
            title="目前学生入队时首次佩戴的队徽徽章是否由学校统一配发"
            :value="format(list.badge, 1)"
          />
        </div>
        <van-cell
          v-if="list.redScarfMedal"
          title="目前学校是否开展“红领巾奖章”基础章争章活动"
          :value="format(list.redScarfMedal, 1)"
        />

        <div v-if="list.redScarfMedal == 1">
          <van-cell
            v-if="list.oneStar"
            title="是否颁发了一星章"
            :value="format(list.oneStar, 1)"
          />
        </div>
        <van-cell
          v-if="list.schoolsgw"
          title="学校是否成立学校少工委"
          :value="format(list.schoolsgw, 1)"
        />
        <div v-if="list.schoolsgw == 1">
          <van-cell
            v-if="list.sgwName"
            title="学校少工委主任姓名"
            :value="list.sgwName"
          />
          <van-cell
            v-if="list.sgwJob"
            title="学校少工委主任职务"
            :value="format(list.sgwJob, 5)"
          />
          <van-cell
            v-if="list.sdhsj"
            title="本届少代会召开时间"
            :value="format(list.sdhsj, 6)"
          />
        </div>
      </div>
    </van-cell-group>
  </div>
</template>
<script>
import { format } from "@/common/js/utils";
export default {
  props: {
    list: Object,
    type: Number,
  },
  setup(props) {
    console.log("list", props.list);
    return { format };
  },
};
</script>
<style lang="less" scoped>
@import "@/common/style/mixin";
.u_sh li {
  display: list-item;
  height: 1.5rem;
}
.u_sh .fl {
  width: 90%;
}
.reason {
  font-size: 0.397rem;
  line-height: 1.4;
  color: #fd3535;
  vertical-align: middle;
  margin: 0.4rem;
}
</style>
